import { Dialog, DialogPanel, Transition, TransitionChild } from '@headlessui/react';
import { Fragment, useEffect, useState } from 'react';
import clsx from 'clsx';
import OnBoardingModalStepOne from './OnBoardingModalStepOne';
import { deleteCookie, getCookie, setCookie } from 'cookies-next';
import OnBoardingModalStepTwo from './OnBoardingModalStepTwo';
import useBackendUser from '@/hooks/useBackendUser';
import cookiesConstants from '@/constants/cookies.constants';
export default function OnBoardingModal() {
  const { data: user } = useBackendUser();
  const [showModal, setShowModal] = useState(false);
  const [step, setStep] = useState(1);

  function handleNextStep() {
    setStep(prev => prev + 1);
  }

  function handleOnlySkip() {
    setShowModal(false);
  }

  function handleSkipAndFinish() {
    deleteCookie(cookiesConstants.COOKIES.ONBOARDING.name);
    setCookie(cookiesConstants.COOKIES.NO_ONBOARDING.name, 'true', {
      maxAge: 60 * 60 * 24 * 365,
    });
    setShowModal(false);
  }

  useEffect(() => {
    const onboardingCookie = getCookie(cookiesConstants.COOKIES.ONBOARDING.name);
    const parsedOnboardingCookie = onboardingCookie === 'true';

    if (!user || (user && user.Business && user.Business?.taxIdVerified !== 'NOT_ASSIGNED')) {
      return;
    }

    const userHasCompletedOnBoarding =
      user.canAsk === false && user.canBid === false && user.emailVerified === false;

    if (parsedOnboardingCookie && userHasCompletedOnBoarding === false) {
      setShowModal(true);
    }
  }, [user]);

  return (
    <Transition appear show={showModal} as={Fragment}>
      <Dialog
        as="div"
        className="tw-relative tw-z-[9999] max-nine:tw-p-2"
        onClose={() => setShowModal(false)}
      >
        <div className="tw-fixed tw-inset-0 tw-bg-black tw-bg-opacity-60" />
        <div className="tw-fixed tw-inset-0 tw-flex tw-items-center tw-justify-center tw-p-4">
          <TransitionChild
            as={Fragment}
            enter="tw-ease-out tw-duration-300"
            enterFrom="tw-opacity-0 tw-scale-95"
            enterTo="tw-opacity-100 tw-scale-100"
            leave="tw-ease-in tw-duration-200"
            leaveFrom="tw-opacity-100 tw-scale-100"
            leaveTo="tw-opacity-0 tw-scale-95"
          >
            <DialogPanel
              className={clsx(
                'tw-relative tw-w-full tw-max-w-5xl tw-overflow-hidden tw-rounded-3xl tw-bg-onBoarding tw-bg-cover tw-bg-center tw-shadow-lg'
              )}
            >
              <div
                className={clsx(
                  'tw-w-2/4 tw-bg-main tw-bg-opacity-75 tw-px-11 tw-pb-4 tw-pt-16 max-nine:tw-w-full max-nine:tw-px-4'
                )}
              >
                <div className={clsx(step === 1 ? 'tw-contents' : 'tw-hidden')}>
                  <OnBoardingModalStepOne
                    handleNextStep={handleNextStep}
                    handleOnlySkip={handleOnlySkip}
                    handleSkipAndFinish={handleSkipAndFinish}
                  />
                </div>
                <div className={clsx(step === 2 ? 'tw-contents' : 'tw-hidden')}>
                  <OnBoardingModalStepTwo handleSkipAndFinish={handleSkipAndFinish} />
                </div>
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </Dialog>
    </Transition>
  );
}
